import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { connectorByIndustry } from "@/config/endpoints";

export default function useModuleByIndustry() {
  const query = useQuery({
    queryKey: ["module-by-industry"],
    queryFn: async () => {
      const res = await axiosInstance.get(connectorByIndustry);
      return res.data.data;
    },
  });
  const coreModules = query.data?.map((module: any) => module.coreModelName);
  const nicheModules = query.data?.map((module: any) => module.nicheModelName);

  return {
    modules: query.data,
    coreModules,
    nicheModules,
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
